import gql from 'graphql-tag'

export const adminMapSearch = gql`
  query adminSearch(
    $query: String!
    $unseated: Boolean
    $assignmentPlanId: ID!
    $location: ID
    $searchType: SearchType!
  ) {
    viewer {
      company {
        search(
          query: $query
          type: $searchType
          unseated: $unseated
          assignment_plan_id: $assignmentPlanId
          location: $location
          by_external_id: true
        ) {
          employees(first: 10) {
            edges {
              node {
                id
                name
                noDeskNeeded
                isRemote
                startDate
                endDate
                assets {
                  url(style: "thumbnail")
                }
                department {
                  id
                  name
                  color
                }
                team {
                  id
                  name
                  color
                }
                seat {
                  id
                  floorPlanId
                  external_id
                  floor {
                    id
                  }
                }
                neighborhoods {
                  id
                  name
                  building {
                    id
                    code
                    name
                  }
                  floor {
                    id
                    code
                    name
                  }
                }
                secondarySeats {
                  edges {
                    node {
                      id
                      external_id
                      floorPlanId
                      floor {
                        id
                      }
                    }
                  }
                }
                hotelingDesks {
                  edges {
                    node {
                      id
                      external_id
                    }
                  }
                }
              }
            }
            pageInfo {
              endCursor
              hasNextPage
            }
          }
          spaces(first: 10) {
            edges {
              node {
                id
                name
                spaceType
                externalId
                spaceInteractivity
                floor {
                  id
                  code
                  name
                }
              }
            }
            pageInfo {
              endCursor
              hasNextPage
            }
          }
          departments(first: 10) {
            edges {
              node {
                id
                name
                colors
              }
            }
            pageInfo {
              endCursor
              hasNextPage
            }
          }
          neighborhoods(first: 10) {
            edges {
              node {
                id
                name
                color
                building {
                  id
                  code
                  name
                }
                floor {
                  id
                  code
                  name
                }
              }
            }
            pageInfo {
              endCursor
              hasNextPage
            }
          }
        }
      }
    }
  }
`
export const adminDepartmentSearch = gql`
  query adminDepartmentSearch(
    $query: String!
    $unseated: Boolean
    $assignmentPlanId: ID!
    $location: ID
    $after: String
  ) {
    viewer {
      company {
        search(
          query: $query
          type: departments
          unseated: $unseated
          assignment_plan_id: $assignmentPlanId
          location: $location
          by_external_id: true
        ) {
          departments(first: 10, after: $after) {
            edges {
              node {
                id
                name
                colors
              }
            }
            pageInfo {
              endCursor
              hasNextPage
            }
          }
        }
      }
    }
  }
`
export const adminSpaceSearch = gql`
  query adminSpaceSearch(
    $query: String!
    $unseated: Boolean
    $assignmentPlanId: ID!
    $location: ID
    $after: String
  ) {
    viewer {
      company {
        search(
          query: $query
          type: spaces
          unseated: $unseated
          assignment_plan_id: $assignmentPlanId
          location: $location
          by_external_id: true
        ) {
          spaces(first: 10, after: $after) {
            edges {
              node {
                id
                name
                spaceType
                externalId
                spaceInteractivity
                floor {
                  id
                  code
                  name
                }
              }
            }
            pageInfo {
              endCursor
              hasNextPage
            }
          }
        }
      }
    }
  }
`
export const adminNeighborhoodSearch = gql`
  query adminNeighborhoodSearch(
    $query: String!
    $unseated: Boolean
    $assignmentPlanId: ID!
    $location: ID
    $after: String
  ) {
    viewer {
      company {
        search(
          query: $query
          type: neighborhoods
          unseated: $unseated
          assignment_plan_id: $assignmentPlanId
          location: $location
          by_external_id: true
        ) {
          neighborhoods(first: 10, after: $after) {
            edges {
              node {
                id
                name
                color
                building {
                  id
                  code
                  name
                }
                floor {
                  id
                  code
                  name
                }
              }
            }
            pageInfo {
              endCursor
              hasNextPage
            }
          }
        }
      }
    }
  }
`
export const adminEmployeeSearch = gql`
  query adminEmployeeSearch(
    $query: String!
    $unseated: Boolean
    $assignmentPlanId: ID!
    $location: ID
    $after: String
  ) {
    viewer {
      company {
        search(
          query: $query
          type: employees
          unseated: $unseated
          assignment_plan_id: $assignmentPlanId
          location: $location
          by_external_id: true
        ) {
          employees(first: 10, after: $after) {
            edges {
              node {
                id
                name
                noDeskNeeded
                assets {
                  url(style: "thumbnail")
                }
                department {
                  id
                  name
                  color
                }
                team {
                  id
                  name
                  color
                }
                seat {
                  id
                  floorPlanId
                  external_id
                }
                neighborhoods {
                  id
                  name
                  building {
                    id
                    code
                    name
                  }
                  floor {
                    id
                    code
                    name
                  }
                }
                secondarySeats {
                  edges {
                    node {
                      id
                      external_id
                      floorPlanId
                    }
                  }
                }
                hotelingDesks {
                  edges {
                    node {
                      id
                      external_id
                    }
                  }
                }
                startDate
                endDate
              }
            }
            pageInfo {
              endCursor
              hasNextPage
            }
          }
        }
      }
    }
  }
`
export const adminEmployeeSpaceSearch = gql`
  query adminEmployeeBookingSearch($ids: [ID]!) {
    viewer {
      company {
        employeeConnection(where: { id_in: $ids }) {
          edges {
            node {
              id
              name
              email
              bookings {
                startDate
                endDate
                checkedIn
                passedHealthCheck
                space {
                  id
                  externalId
                  x
                  y
                  floor {
                    id
                    code
                    name
                    building {
                      id
                      code
                      name
                      city
                      timezone
                      address
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`
